import { dataProps } from './properties'

export const setSaleTagList = (state, payload) => {
    state.list = payload
}    

export const setSaleTagData = (state, payload) => {
    state.props = payload
} 

export const resetSaleTagData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/saleTag/mutations.js